
export default {
  mounted() {
    document.body.classList.add("authentication-bg");
  },
};
